<template>
  <b-row
    v-if="patientIdentifier"
    class="identifier-card p-1 d-flex align-items-center"
    :class="{'new-item': isNewItem}"
  >
    <b-col
      cols="2"
      class="pr-1 pl-2 truncate"
    >
      <span v-tooltip="patientIdentifier.identifierType.name"><strong>{{ patientIdentifier.identifierType.name }}</strong></span>
    </b-col>
    <b-col
      cols="3"
      class="px-1"
    >
      <span>{{ patientIdentifier.identifierValue }}</span>
    </b-col>
    <b-col
      v-if="patientIdentifier.center && patientIdentifier.center.name"
      cols="5"
      class="px-1 truncate"
    >
      <span>{{ patientIdentifier.center.name }}</span>
    </b-col>
    <b-col class="more-btn p-0 d-flex justify-content-end">
      <slot />
    </b-col>
  </b-row>
</template>

<script>

export default {
    name: 'PatientIdentifierItem',
    props: {
        patientIdentifier: { type: Object, default: () => {} }
    },
    computed: {
        isNewItem() {
            return !this.patientIdentifier || !this.patientIdentifier.paiId
        }
    }
}

</script>

<style lang="scss" scoped>

    .identifier-card {
        @include general-card();
    }

    .identifier-card.new-item {
        background: vt-color(success, .8);
    }

    .identifier-card span {
        font-size: font-size(very-small);
    }

    .truncate {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

</style>
